/* eslint-disable */
import React, { useState } from "react";
// import InfoIcon from "./InfoIcon";

const TileNewIcon = ({ title, number, gradient, popupContent }) => {
  const [showPopup, setShowPopup] = useState(false);

  const tileStyle = {
    width: "100%",
    minWidth: "150px",
    // minHeight: "120px",
    minHeight: "175px",
    position: "relative",
    borderRadius: 16,
    background: gradient || "linear-gradient(135deg, #F43F5E, #DB2777)",
    padding: "12px 16px",
    boxSizing: "border-box",
    overflow: "hidden",
    color: "white",
    transition: "all 0.2s ease",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    boxShadow: "4px 4px 8px rgba(0, 0, 0, 0.4)"
  };

  const titleStyle = {
    color: "white",
    fontSize: "1.3rem",
    fontWeight: 500,
    fontFamily: "Roboto",
    lineHeight: "1.2",
  };

  const numberStyle = {
    color: "white",
    fontSize: "1.5rem",
    fontWeight: 700,
    // marginTop: "4px",
    fontFamily: "Roboto",
  };

  return (
    <div
      style={tileStyle}
      onMouseEnter={() => setShowPopup(true)}
      onMouseLeave={() => setShowPopup(false)}
    >
      {showPopup ? (
        <div
          style={{
            fontSize: "12px",
            lineHeight: "18px",
            height: "100%",
            display: "flex",
            alignItems: "center",
            textAlign: "left",
            paddingRight: "10px",
          }}
        >
          {popupContent}
        </div>
      ) : (
        <>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "5px" }}>
            <div style={titleStyle}>{title || "Metric Name"}</div>
            {/* <InfoIcon popupContent={popupContent} inlineMode={true} /> */}
          </div>
          <div style={numberStyle}>{number}</div>
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              width: "100%",
              height: "40%",
              overflow: "hidden",
              borderRadius: "0 0 16px 16px",
            }}
          >
            <svg
              viewBox="0 0 1440 320"
              preserveAspectRatio="none"
              style={{
                width: "200%",
                height: "100%",
                animation: "waveSlide 8s linear infinite",
              }}
            >
              <path
                fill="rgba(255,255,255,0.20)"
                d="M0,224L80,218.7C160,213,320,203,480,192C640,181,800,171,960,176C1120,181,1280,203,1360,213.3L1440,224L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
              />
            </svg>
          </div>
        </>
      )}

      <style>
        {`
          @keyframes waveSlide {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}
      </style>
    </div>
  );
};

export default TileNewIcon;
